import React, { Component } from 'react';

//import HeaderImage from "../../assets/images/bluechip.svg";

//components
import Navigation from 'modules/navigation';

//images
import HeaderImage from 'assets/images/canlease-logo.png';

//style
import './Header.css';

export default class Header extends React.Component {
    render() {
        const nav = this.props.appState.auth ? <Navigation /> : '';

        return (
            <header>
                <img src={HeaderImage} />
                {nav}
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/header/Header.jsx